import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface CameraStatus {
  partner_id: number;
  vehicle_id: number;
  camera_id: string;
  vin_id: string;
  last_sync_date: Date;
  camera_online_status: boolean;
  audit_logs: CameraAuditLogEntry[];
}

export interface CameraAuditLogEntry {
  partner_id: number;
  vehicle_id: number;
  vin_id: string;
  last_sync_date: Date;
  camera_online_status: boolean;
  device_id: string;
  camera_id: number | string;
}

@Injectable({ providedIn: 'root' })
export class CameraStatusService implements OnDestroy {
  private readonly driverCameraStatusMap$ = new Map<number, BehaviorSubject<CameraStatus>>();

  watchStatus(partner_id: number, initial?: CameraStatus): Observable<CameraStatus> {
    if (!this.driverCameraStatusMap$.has(partner_id)) {
      const initialStatus = initial ?? {
        partner_id,
        vehicle_id: 0,
        camera_id: '',
        vin_id: '',
        last_sync_date: new Date(0),
        camera_online_status: false,
        audit_logs: [],
      };

      this.driverCameraStatusMap$.set(partner_id, new BehaviorSubject<CameraStatus>(initialStatus));
    } else if (initial) {
      // If a stream exists and caller provided an initial snapshot, emit it immediately
      this.driverCameraStatusMap$.get(partner_id)!.next(initial);
    }
    return this.driverCameraStatusMap$.get(partner_id)!.asObservable();
  }
  updateStatus(partner_id: number, status: CameraStatus): void {
    if (this.driverCameraStatusMap$.has(partner_id)) {
      this.driverCameraStatusMap$.get(partner_id)!.next(status);
    } else {
      this.driverCameraStatusMap$.set(partner_id, new BehaviorSubject<CameraStatus>(status));
    }
  }

  getCurrentStatus(partner_id: number): CameraStatus | null {
    const subject = this.driverCameraStatusMap$.get(partner_id);
    return subject ? subject.getValue() : null;
  }

  ngOnDestroy(): void {
    // Complete all BehaviorSubjects
    this.driverCameraStatusMap$.forEach(subject => subject.complete());
    this.driverCameraStatusMap$.clear();
  }
}
